import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import { number, string, shouldUpdate } from "../../../../utils";

import styles from "./styles.scss";

let count = 0;
const idPrefix = "occurrencesTable";

@CSSModules(styles, { allowMultiple: true })
class OccurrencesTable extends Component {
	constructor(props) {
		super(props);
		this.stringify = this.stringify.bind(this);
		this.props.initTable(this.props.id, this.props.component);
	}
	render() {
		if (!this.props.tableData) {
			return <div />;
		}
		return (
			<div styleName="component-wrapper occurrence-wrapper">
				<div styleName="component-title">{this.props.component.chartTitle || "Occurrences"}</div>
				<div styleName="occurrences-table-container">
					<table styleName="occurrences-table">
						<thead>
							<tr>
								{this.props.tableData.headers.map((header, index) => (
									<th
										key={index}
										left={index === 0 || index === 1 ? "true" : ""}
										styleName="table-header"
									>
										{header}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{this.props.tableData.rows.map((row, index) => (
								<tr key={index} styleName="occurrence-data">
									<td>{row.dateString}</td>
									<td>{row.status}</td>
									{row.points.map((point, index2) => (
										<td
											styleName="occurrence-value"
											key={index2}
											style={{
												color: point.state === 3 ? "red" : point.state === 2 ? "green" : undefined
											}}
										>
											{number.parseNumber(point.value, point.decimalPlaces)} {point.units}
										</td>
									))}
									{row.args.map((arg, index2) => (
										<td styleName="occurrence-value" key={index2}>
											{this.stringify(arg)}
										</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		);
	}

	stringify(obj) {
		let rtn = "";
		if (typeof obj === "object") {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					const item = obj[prop];
					if (typeof item === "object") {
						rtn += this.stringify(item) + "\n";
					} else {
						rtn += `${string.capitalizeFirstLetter(prop)}: ${
							!isNaN(item) ? number.parseNumber(item) : item
						}\n`;
					}
				}
			}
		} else {
			rtn += (!isNaN(obj) ? number.parseNumber(obj) : obj) + "\n";
		}
		return rtn.replace(/\n$/, "");
	}

	setup() {
		this.props.loadData(this.props.id, this.props.component, this.props.timePeriod, this.props.onLoadComplete);
	}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.tableData != this.props.tableData) {
			return true;
		} else if (prevProps.component != this.props.component || prevProps.timePeriod != this.props.timePeriod) {
			this.setup();
			return false;
		} else {
			return false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (id, component, timePeriod, onLoadComplete) =>
			dispatch(actions.loadData(id, component, timePeriod, onLoadComplete)),
		initTable: (id, component) => dispatch(actions.initTable(id, component))
	};
};

const mapStateToProps = (state, ownProps) => ({
	tableData: state.occurrencestable.instances[ownProps.id]
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(OccurrencesTable)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/OccurrencesTable/OccurrencesTable.js